import { useVehicleDataHandler } from '../hooks/useVehicleDataHandler';
import { useEquipmentHandler } from '../hooks/useEquipmentHandler';
import { usePhotosHandler } from '../hooks/usePhotosHandler';
import { useDetailsHandler } from '../hooks/useDetailsHandler';
import { useContactHandler } from '../hooks/useContactHandler';

export const useStepHandlers = () => {
  const vehicleDataHandler = useVehicleDataHandler();
  const equipmentHandler = useEquipmentHandler();
  const photosHandler = usePhotosHandler();
  const detailsHandler = useDetailsHandler();
  const contactHandler = useContactHandler();

  return [
    vehicleDataHandler,
    equipmentHandler,
    photosHandler,
    detailsHandler,
    contactHandler,
  ];
};
